import { giphyLightGrey, giphyLightestGrey } from '@giphy/colors'
import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { Button as ButtonComponent, IconButton } from 'ui'
import { borderRadiusFromControlSize, fontSizeFromControlSize, heightFromControlSize } from 'utils'

export const buttonPadding = css`
    padding: 0 0.8em;
`

export const Avatar = styled.img`
    border-radius: 2px;
    height: 20px;
    margin-right: 0.2em;
    width: 20px;
`

export const Button = styled(ButtonComponent)`
    ${buttonPadding}
    font-weight: inherit;
    text-align: left;
    width: 100%;
`

export const PresetButton = styled(IconButton)`
    flex-shrink: 0;
    min-width: 30px;
    opacity: 0.8;
    transition: opacity 0.1s ease-out;
    width: 30px;

    &:hover {
        opacity: 1;
    }
`

export const LinkButton = styled(PresetButton)`
    opacity: 0.5;
`

export const Preset = styled.div<{ $active: boolean; $size: ControlSize }>`
    display: flex;
    font-weight: normal;

    ${({ $size }) => css`
        border-radius: ${borderRadiusFromControlSize($size)}px;
        height: ${heightFromControlSize($size)}px;
    `}

    ${({ $active }) =>
        $active
            ? css`
                  color: ${giphyLightestGrey};

                  ${PresetButton} {
                      opacity: 1;
                  }
              `
            : css`
                  color: ${giphyLightGrey};
                  transition: color 0.1s ease-out;

                  &:hover {
                      color: ${giphyLightestGrey};
                  }
              `}
`

export const PresetInfo = styled.div<{ $size: ControlSize }>`
    ${buttonPadding}
    align-items: center;
    display: flex;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;

    ${({ $size }) => css`
        font-size: ${fontSizeFromControlSize($size)}px;
        height: ${heightFromControlSize($size)}px;
    `}
`
